/** @jsx jsx */
import { jsx, useTheme } from "@emotion/react";

import { useIntl } from "react-intl";
import { PurposedButtonProps } from "./types";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";

const LogOutButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.secondaryColor}
      tooltip={formatMessage({ id: "login.logout" })}
      iconName="exit_to_app"
      css={labellessButtonCss}
      dataCy="log-out-button"
      {...props}
    />
  );
};

export default LogOutButton;
